import Breadcrumb from "../../components/Reusable/Breadcrumb";
import ProfileItemLink from "../Profile/ProfileItemLink";
import React from "react";
import { t } from "i18next"; // Import t function for translation

const Information = () => {
  return (
    <div className="information-main-container">
      <Breadcrumb title={t("settings_page")} returnPage="/profile" />
      <div className="information-list-items">
        <ProfileItemLink title={t("contact_us")} link={"/chat"} />
        <ProfileItemLink title={t("faq")} link={"/faq"} />
        <ProfileItemLink title={t("terms_page")} link={"/privacy-policy"} />
        <ProfileItemLink
          title={t("terms_page_condition")}
          link={"/terms-conditions"}
        />
      </div>
    </div>
  );
};

export default Information;
